import { queryOptions } from '@tanstack/react-query';

import { queryKeys } from '@constants/queryKeys.constant';
import { EStaleTime } from '@enums/staleTime.enum';

import { sessionsService } from './service';

export function currentSessionQueryOptions() {
  return queryOptions({
    queryFn: () => sessionsService.getCurrent(),
    queryKey: queryKeys.sessions.current(),
    // 401/403 are answers, not transient failures.
    retry: false,
    staleTime: EStaleTime.TwoMinutes,
  });
}
